import api from '@/services/api/api';

export const useAuthorSubscribeHandler = (data) => {
  const authStore = useAuthStore();
  const modalsStore = useModalsStore();
  const toast = useToast();
  const isSubscribed = ref(!!toValue(data)?.is_subscribed);

  const handleSubscribe = async (author) => {
    if (!authStore.isAuthorized) {
      modalsStore.showEmailAuthForm();
    } else {
      try {
        const { data } = await api.user.subscribeAuthor(author.id);
        if (data === 'Ok') {
          toast.success('Вы успешно подписались на автора.');
          isSubscribed.value = true;
        } else if (data === 'Deleted') {
          toast.success('Вы успешно отписались.');
          isSubscribed.value = false;
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  return {
    isSubscribed,
    handleSubscribe,
  };
};
